import { useEffect } from 'react'

/**
 * Fija el título de la pestaña y lo restaura si otro script (por ejemplo el
 * chat de Tawk.to) intenta cambiarlo.
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title

    const titleEl = document.querySelector('title')
    if (!titleEl) return

    const observer = new MutationObserver(() => {
      if (document.title !== title) document.title = title
    })
    observer.observe(titleEl, { childList: true, characterData: true, subtree: true })

    return () => observer.disconnect()
  }, [title])
}
